import { isWeb } from 'tamagui'
import { useEffect } from 'react'

type KeyPressHandler = (event: KeyboardEvent) => void

/**
 * Does something when a key is pressed.
 * Example: useOnKeyPress('Enter', handleSubmit, inputRef)
 */
export const useOnKeyPress = (
  targetKey: string,
  handler: KeyPressHandler,
  elementRef?: React.RefObject<Element>
) => {
  useEffect(() => {
    if (!isWeb) return
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === targetKey && !event.shiftKey && !event.ctrlKey && !event.altKey) {
        event.preventDefault()
        handler(event)
      }
    }

    const targetElement = elementRef?.current ? elementRef.current : document.body

    if (targetElement) {
      targetElement.addEventListener('keydown', onKeyDown)
    }

    return () => {
      if (targetElement) {
        targetElement.removeEventListener('keydown', onKeyDown)
      }
    }
  }, [targetKey, handler, elementRef])
}
